import React from "react";
import { FaPaypal, FaUniversity } from "react-icons/fa";
import { SiStripe } from "react-icons/si";
import { Box, Grid, Typography, Link, Button } from "@mui/material";
import logo from "../../Assets/Images/BLU TAXI white logo.png";
import { useNavigate } from "react-router-dom";
import { paths } from "../../config/constants";
// import "./footer.css";  // assuming CSS defined below

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer-container">
      {/* Top: Brand + CTA Buttons */}
      {/* Top: Brand Left + Buttons Right */}
<Box className="footer-top-cta footer-top-cta--row">
   <Link to={paths.home}>
                  <img src={logo} width="180" height="70" alt="Logo" />
                </Link>
  <Box className="footer-cta-buttons">
    <Button
      variant="contained"
      className="footer-btn footer-btn-register-company"
      href="/accounts/agent-register"
    >
     Company / Agent Registration
    </Button>
    <Button
      variant="contained"
      className="footer-btn footer-btn-register-carrier"
      href="/accounts/driver-carrier-registration"
    >
      Carrier Registration
    </Button>
  </Box>
</Box>


      {/* Separator line */}
      <Box className="footer-separator" />

      {/* Link Columns */}
      <Box className="footer-links-wrapper">
      <Box className="footer-links-group">
        <Grid container spacing={4}>
          {/* Column 1 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">Become blu partner</Typography>
            <ul>
              <li onClick={() => navigate(paths.aboutUs)}><Link>How blu.taxi works</Link></li>
              <li onClick={() => navigate(paths.accounts.socialLogin)}><Link>User Registration</Link></li>
              <li onClick={() => navigate(paths.accounts.agentRegister)}><Link>Company/Agent Registration</Link></li>
              <li onClick={() => navigate(paths.accounts.driverCarrierRegister)}><Link>Carrier Registration</Link></li>
            </ul>
          </Grid>

          {/* Column 2 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">blu.taxi for Business</Typography>
            <ul>
              <li onClick={() => navigate(paths.qans)}><Link>Faqs</Link></li>
              <li onClick={() => navigate(paths.bookingTermsAndCond2)}><Link>Terms and conditions</Link></li>
              <li onClick={() => navigate(paths.privacyPolicy)}><Link>Privacy policy</Link></li>
              {/* <li onClick={() => navigate(paths.cancellationPolicy)}><Link>Cancellation Policy</Link></li> */}
              <li onClick={() => navigate(paths.businessAgentTermsAndCondition2)}><Link>Terms and conditions for agent</Link></li>
              <li onClick={() => navigate(paths.companyTermsAndCondition2)}><Link>Terms and conditions for company</Link></li>
              <li onClick={() => navigate(paths.carrierTermsAndConditions2)}><Link>Terms and conditions for carrier</Link></li>
            </ul>
          </Grid>

          {/* Column 3 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">Top Cities</Typography>
            <ul>
              <li><Link href="#">New York</Link></li>
              <li><Link href="#">London</Link></li>
              <li><Link href="#">Berlin</Link></li>
              <li><Link href="#">Los Angeles</Link></li>
              <li><Link href="#">Paris</Link></li>
              <li><Link href="#">All cities</Link></li>
            </ul>
          </Grid>

          {/* Column 4 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">Explore blu</Typography>
            <ul>
              <li  onClick={() => navigate(paths.cityToCityRides)}><Link>City To City Rides</Link></li>
              <li  onClick={() => navigate(paths.airportTransfer)}><Link>Airport Transfer</Link></li>
              <li  onClick={() => navigate(paths.businessTransfer)}><Link>Business Transfer</Link></li>
              <li  onClick={() => navigate(paths.tourAndEventTransfer)}><Link>Tour And Event Transfer</Link></li>
              <li  onClick={() => navigate(paths.baggageTransfer)}><Link>Baggage Transfer Service</Link></li>
              <li  onClick={() => navigate(paths.petTransfer)}><Link>Pet Transfer Service</Link></li>
              <li  onClick={() => navigate(paths.patientTransfer)}><Link>Patient Transfer Service</Link></li>
              <li  onClick={() => navigate(paths.vipService)}><Link>Vip Service</Link></li>
            </ul>
          </Grid>

          {/* Column 5 */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6">City‑to‑City Rides <span className="badge-new">NEW</span></Typography>
            <ul>
              <li><Link href="#">New York – East Hampton</Link></li>
              <li><Link href="#">Los Angeles – San Diego</Link></li>
              <li><Link href="#">Miami – Palm Beach</Link></li>
              <li><Link href="#">London – Bristol</Link></li>
              <li><Link href="#">Dubai – Abu Dhabi</Link></li>
              <li><Link href="#">Paris – Reims</Link></li>
            </ul>
          </Grid>
        </Grid>
      </Box>
      </Box>

      {/* Bottom bar: copyright etc */}
      {/* <Box className="footer-bottom-bar">
        <Typography variant="body2">© {new Date().getFullYear()} blu.taxi</Typography>
        <Box className="footer-bottom-links">
          <Link href="#">Terms</Link>
          <Link href="#">Privacy policy</Link>
          <Link href="#">Legal notice</Link>
          <Link href="#">Accessibility</Link>
        </Box>
      </Box> */}
      <Box className="footer-bottom-bar">
  {/* Left: Copyright */}
   <Box className="footer-bottom-left">
    <FaPaypal className="footer-payment-icon paypal" />
    <SiStripe className="footer-payment-icon stripe" />
    <FaUniversity className="footer-payment-icon bank" />
  </Box>
  <Box className="footer-bottom-right">
    <Typography variant="body2">© {new Date().getFullYear()} blu.taxi</Typography>
        <Box className="footer-bottom-links">
          <Link href="#">Terms</Link>
          <Link href="#">Privacy policy</Link>
          <Link href="#">Legal notice</Link>
          <Link href="#">Accessibility</Link>
        </Box>
  </Box>

 
</Box>
    </footer>
  );
};

export default Footer;
